import React, { useEffect, useMemo, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import axios from "axios";
import MainLayer from "../components/main_layer";
import Makondo from "../pages/makondo.jsx";
import Rooms from "../pages/rooms.jsx";
import Room from "../pages/room.jsx";
import MoreMonte from "../pages/moreMonte.jsx";
import Confid from "../pages/confident.jsx";
import Confirmation from "../pages/confirmation.jsx";
import ConfirmationProblem from "../pages/confirmation_problem.jsx";
import Booking from "../pages/booking.jsx";
import Start from "../pages/StartPage.jsx";

import { room_1, room_2, room_3 } from "../assets/rooms_img.jsx";
import { description_room1, description_room2, description_room3 } from "../description";
import { SERVER } from "../config.jsx";

const server = SERVER || "http://localhost:5000";

export default function AppRouter() {
  const sessionStart = sessionStorage.getItem("lang") || "ru";
  const [lang, setLang] = useState(sessionStart);

  const [info, setInfo] = useState([
    { price: "", currency: "" },
    { price: "", currency: "" },
    { price: "", currency: "" },
  ]);

  const onLang = (lng) => () => setLang(lng);

  useEffect(() => {
    sessionStorage.setItem("lang", lang);
  }, [lang]);

  useEffect(() => {
    const ax = axios.create({
      baseURL: `${server}/`,
      timeout: 5000,
      withCredentials: false,
    });

    ax.get("api/user/rooms").then((response) => {
      setInfo(response.data);
    });
  }, []);

  const layoutProps = useMemo(() => ({ lang, onLang }), [lang]);

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <MainLayer {...layoutProps}>
              <Start lang={lang} link={true} />
            </MainLayer>
          }
        />
        <Route
          path="/makondo"
          element={
            <MainLayer {...layoutProps}>
              <Makondo lang={lang} link={false} />
            </MainLayer>
          }
        />
        <Route
          path="/rooms"
          element={
            <MainLayer {...layoutProps}>
              <Rooms lang={lang} link={false} Info={info} />
            </MainLayer>
          }
        />
        <Route
          path="/room_1"
          element={
            <MainLayer {...layoutProps}>
              <Room
                number="1"
                room={room_1}
                description_room={description_room1}
                lang={lang}
                link={false}
                Info={info}
              />
            </MainLayer>
          }
        />
        <Route
          path="/room_2"
          element={
            <MainLayer {...layoutProps}>
              <Room
                number="2"
                room={room_2}
                description_room={description_room2}
                lang={lang}
                link={false}
                Info={info}
              />
            </MainLayer>
          }
        />
        <Route
          path="/room_3"
          element={
            <MainLayer {...layoutProps}>
              <Room
                number="3"
                room={room_3}
                description_room={description_room3}
                lang={lang}
                link={false}
                Info={info}
              />
            </MainLayer>
          }
        />
        <Route
          path="/booking"
          element={
            <MainLayer {...layoutProps}>
              <Booking lang={lang} link={false} Info={info} />
            </MainLayer>
          }
        />
        <Route
          path="/more"
          element={
            <MainLayer {...layoutProps}>
              <MoreMonte lang={lang} link={false} />
            </MainLayer>
          }
        />
        <Route
          path="/confid"
          element={
            <MainLayer {...layoutProps}>
              <Confid lang={lang} link={false} />
            </MainLayer>
          }
        />
        <Route
          path="/confirmation_ok"
          element={
            <MainLayer {...layoutProps}>
              <Confirmation lang={lang} link={false} answer={true} />
            </MainLayer>
          }
        />
        <Route
          path="/confirmation_no"
          element={
            <MainLayer {...layoutProps}>
              <Confirmation lang={lang} link={false} answer={false} />
            </MainLayer>
          }
        />
        <Route
          path="/confirmation_problem"
          element={
            <MainLayer {...layoutProps}>
              <ConfirmationProblem lang={lang} />
            </MainLayer>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

